import React from 'react'

import Button from '../../app/design/Button'
import Modal from '../../app/design/Modal'

type Props = {
    title: string
    children: React.ReactNode
    buttonText: string
    extraButtonText?: string
    disableDismiss?: boolean
    dismissButtonText?: string
    onClose: () => void
    onAction: (button?: number) => void
    size?: 'large' | 'medium' | 'small'
}

export const GuardrailModal = ({
    title,
    buttonText,
    extraButtonText,
    disableDismiss,
    dismissButtonText,
    onClose,
    onAction,
    size = 'large',
    children,
}: Props) => {
    return (
        <Modal
            onClose={onClose}
            isOpen={true}
            title={title}
            showDividers={false}
            size={size}
            footer={
                <div className="flex justify-end gap-x-2">
                    {disableDismiss !== true && (
                        <Button intent="secondary" onClick={onClose}>
                            {dismissButtonText ?? 'Back'}
                        </Button>
                    )}
                    {extraButtonText && (
                        <Button intent="primary" onClick={() => onAction(2)}>
                            {extraButtonText}
                        </Button>
                    )}
                    <Button intent="primary" onClick={() => onAction(1)}>
                        {buttonText}
                    </Button>
                </div>
            }
        >
            {children}
        </Modal>
    )
}
